import React from "react";
import solutions from "../solutions.json";
import clients from "../clients.json";
import cycles from "../cycles.json";
import tech from "../tech.json";
import contacts from "../contacts.json";
import { InputString, InputNumber, InputText, Button } from "../nq-component";
import { upsertUseCase, findObjectUseCase } from "../usecases";
import { useNavigate } from "react-router-dom";

const upsert = upsertUseCase();
const find = findObjectUseCase();

function Main() {
  const [change, setChange] = React.useState({});
  const [progress, setProgress] = React.useState(false);
  const [merchants, setMerchants] = React.useState(null);
  const [events, setEvents] = React.useState(null);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setProgress(true);
    try {
      change.source = "Website";
      await upsert.execute("leads", change);
      navigate("/thanks");
    } catch (e) {
      console.error(e);
    }
    setProgress(false);
  }

  async function getMerchant() {
    try {
      const merchantResponse = await find.execute("merchants");
      const eventResponse = await find.execute("events");
      setMerchants(merchantResponse);
      setEvents(eventResponse);
    } catch (error) {
      throw error;
    }
  }

  React.useEffect(() => {
    getMerchant();
  }, []);

  function onChange(field, value) {
    setChange((state) => ({
      ...state,
      [field]: value,
    }));
  }

  const style = {
    marginTop: "200px",
  };

  console.log("Merchant: ", merchants);
  console.log("Events: ", events);
  return (
    <>
      <hr className="m-0" />
      <div className="overflow-auto" id="scrollableDiv">
        <div className="arrow-animation">
          <img src="/logo-animation-dark.png" />
        </div>
        <div className="container p-3 px-lg-5 py-lg-4">
          <section
            id="home"
            className="text-center d-flex"
            style={{ height: `calc(100vh - 120px)` }}
          >
            <div className="m-auto">
              <h1 className="display-3 fw-bold" style={{ color: "#2d4781" }}>
                Join Our
              </h1>
              <h2 className="display-3 fw-bold">Community</h2>
              <h5 className="mt-3">
                "Hindi Lahat ng alam mo ay alam ko at alam ko ay alam mo"
              </h5>
              <div className="mb-5">
                <a
                  href="https://www.facebook.com/groups/2241325105938660"
                  className="btn mt-5"
                  style={{ backgroundColor: "#1f1c58", color: "white" }}
                >
                  Join Now
                </a>
              </div>

              <img src="/home.png" height="200" />
            </div>
          </section>
          {/* <section id="shop" className="mt-5">
            <div className="text-center mb-4">
              <h2 className="fw-bold">Merchandise</h2>
            </div>
            <div className="row">
              {merchants?.map((item) => (
                <div key={item.id} className="col-6 col-sm-4 col-md-3 mb-4">
                  <div className="card h-100 border-0">
                    <img
                      src={item.picture}
                      className="card-img-top"
                      alt={item.name}
                      style={{ objectFit: "cover", height: "200px" }}
                    />
                    <div className="card-body text-center">
                      <p className="h5 mb-2">₱{item.price}</p>
                      <p className="mb-0">{item.name}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-2">
              <a
                href="/shop"
                className="btn btn-lg px-5"
                style={{ backgroundColor: "#2d4781", color: "white" }}
              >
                Shop Now
              </a>
            </div>
          </section> */}

          <section id="events" className="mt-5">
            <div className="text-center mb-4">
              <h2 className="fw-bold">PD – Events</h2>
            </div>

            <div className="row justify-content-center">
              {events?.map((evt) => (
                <div key={evt.id} className="col-12 col-sm-6 col-lg-3 mb-4">
                  <div className="card h-100 shadow-sm">
                    {/* <img
                      src={evt.picture}
                      className="card-img-top"
                      alt={evt.title}
                      style={{ objectFit: "cover", height: "200px" }}
                    /> */}
                    <img
                      src={evt.picture}
                      alt={evt.eventName}
                      className="rounded-3 mb-3 img-fluid"
                      style={{
                        width: "100%",
                        height: "auto", // ← no more fixed 150px
                      }}
                    />

                    <div className="card-body text-start">
                      <h5 className="card-title">{evt.title}</h5>

                      <ul className="list-unstyled mb-3 small text-muted">
                        <li>
                          <i
                            className="bi bi-calendar3 me-2"
                            style={{ color: "#ef5555" }}
                          />
                          {new Date(evt.eventDate).toLocaleDateString(
                            undefined,
                            {
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            },
                          )}
                        </li>
                        <li>
                          <i
                            className="bi bi-clock me-2"
                            style={{ color: "#ef5555" }}
                          />
                          {evt.startTime} - {evt?.endTime}
                        </li>
                        <li>
                          <i
                            className="bi bi-geo-alt me-2"
                            style={{ color: "#ef5555" }}
                          />
                          {evt.location}
                        </li>
                      </ul>

                      <div className="d-flex ">
                        <Button
                          className="flex-fill "
                          style={{
                            backgroundColor: "#1f1c58",
                            color: "white",
                            fontWeight: "bold",
                            padding: "10px",
                            borderRadius: "20px",
                          }}
                        >
                          <i
                            className="bi bi-arrow-up-right-circle-fill me-2"
                            style={{ color: "#ef5555" }}
                          ></i>
                          <a
                            href="https://event.programmersdevelopers.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-100 text-white"
                          >
                            Register
                          </a>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="aboutUs" className="mt-5">
            <div className="container">
              {/* Title */}
              <h2 className="fw-bold text-center mb-4">About Us</h2>

              {/* Two-column layout: logo on the left, text + button on the right */}
              <div className="">
                {/* Logo */}
                <div className="col-12 text-center mb-3 mb-md-0">
                  <img
                    src="/Logo-02.png"
                    alt="Our Logo"
                    style={{ width: "140px", height: "auto" }}
                  />
                </div>

                {/* Copy + CTA */}
                <div className="col-12 text-center ">
                  <p className="mb-3">
                    A community for programmers and developers to share
                    knowledge, career tips, and tech insights.
                  </p>
                  <a
                    href="/about"
                    className="btn px-4"
                    style={{
                      borderRadius: "4px",
                      border: "1px solid #2d4781", // ← your blue
                      color: "#2d4781", // ← match text to border
                      backgroundColor: "transparent",
                    }}
                  >
                    View More
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section
            id="contactUs"
            className="mt-5"
            style={{
              // backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              // padding: "1r",
            }}
          >
            <div className="container">
              {/* Heading */}
              <h2 className="fw-bold text-center mb-4">Contact Us</h2>

              {/* Contact details */}
              <ul className="list-unstyled">
                <li className="d-flex align-items-center mb-3">
                  <i className="bi bi-envelope-fill fs-4 text-danger me-3" />
                  <span className="fw-light">Email :</span>
                  <span className="ms-2" style={{ fontSize: "11px" }}>
                    contact@programmersdevelopers.com
                  </span>
                </li>
                <li className="d-flex align-items-center mb-3">
                  <i className="bi bi-telephone-fill fs-4 text-danger me-3" />
                  <span className="fw-light">Phone Number :</span>
                  <span className="ms-2">0997 608 6635</span>
                </li>
                <li className="d-flex align-items-center">
                  <i className="bi bi-geo-alt-fill fs-4 text-danger me-3" />
                  <span className="fw-light">Location :</span>
                  <span className="ms-2">
                    Sierra Madre st. Malamig, Mandaluyong City
                  </span>
                </li>
              </ul>

              {/* Social links */}
              <div className="text-center mt-4">
                <span className="fw-light me-2">Visit Us :</span>
                <a
                  href="https://www.facebook.com/groups/2241325105938660"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-2"
                >
                  <i className="bi bi-facebook fs-4 text-primary" />
                </a>
                <a
                  href="https://youtube.com/YourChannel"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-2"
                >
                  <i className="bi bi-youtube fs-4 text-danger" />
                </a>
              </div>
            </div>
          </section>

          {/* <section id="clients" style={style} className="text-center">
            <h2 className="fw-bold">Valued Clients</h2>
            <p>A Pleasure to Work With</p>
            <div className="row justify-content-center align-items-center">
              <div className="col-12 col-md-9 mx-5 px-5 align-items-center">
                <div className="row">
                  {clients.map((client, index) => (
                    <div
                      key={"client-" + index}
                      className="col-6 col-md-4 mt-3"
                    >
                      <img className="img-fluid grayscale" src={client.logo} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
          <section id="contact">
            <div className="row">
              <div className="col-md-6 mt-5">
                <h2 className="fw-bold">Message Us</h2>
                <form onSubmit={onSubmit} className="mt-3">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <label className="form-label fs-sm">Full Name</label>
                      <InputString
                        onChange={onChange.bind(this, "name")}
                        className="form-control"
                        placeholder="e.g. Juan Dela Cruz"
                        type="text"
                        required
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="form-label fs-sm">Email Address</label>
                      <InputString
                        onChange={onChange.bind(this, "email")}
                        type="email"
                        autoComplete="nope"
                        className="form-control"
                        placeholder="e.g. username@domain.com"
                        required
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="form-label fs-sm">Mobile No.</label>
                      <InputNumber
                        onChange={onChange.bind(this, "mobile")}
                        autoComplete="nope"
                        className="form-control"
                        placeholder="e.g. 09987654321"
                        parse={false}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="form-label fs-sm">Your Message</label>
                      <InputText
                        onChange={onChange.bind(this, "description")}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="text-center mt-3">
                    <Button
                      progress={progress}
                      type="submit"
                      className="btn btn-primary w-50"
                    >
                      SUBMIT
                    </Button>
                  </div>
                </form>
              </div>
              <div className="col-md-6 mt-5">
                <h2 className="fw-bold">Contact Us</h2>
                <div className="mt-3">
                  <span className="fs-sm">Contact Information</span>
                  <ul className="list-group list-group-flush">
                    {contacts.map((contact, index) => (
                      <li
                        key={"contact-" + index}
                        className="list-group-item clamp bg-transparent"
                      >
                        <i className={contact.icon} />
                        <span className="ms-2 fw-light">{contact.label}</span>
                        <span className="fs-sm text-nowrap">
                          {contact.value}
                        </span>
                      </li>
                    ))}
                    <li className="list-group-item clamp bg-transparent">
                      <i className="bi bi-globe-americas" />
                      <span className="ms-2 fw-light">Facebook: </span>
                      <a target="_blank" href="https://facebook.com/mweebinc">
                        MWeeb Inc
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section> */}
        </div>
        <footer className="text-center">
          <p>© 2025 programmersdevelopers.com All Rights Reserved</p>
        </footer>
      </div>
    </>
  );
}

export default Main;
